import http from "./http";
import {BookmarkProps} from '../types/bookmark';

const BookmarksService = {
  getBookmarks: () => {
    return http.get('/api/bookmark');
  },
  addBookmark: (bookmark: BookmarkProps) => {
    return http.post('/api/bookmark', bookmark);
  },
  deleteBookmark: (resultId:string) => {
    return http.post('/api/bookmark-delete', {result_id: resultId});
  }
}

export default BookmarksService;